/* Thème clair / sombre.

   Les jetons des deux thèmes vivent déjà dans index.css (`:root` et `.dark`) ;
   ici on ne fait que poser la classe `dark` sur <html> et la mémoriser.

   ATTENTION — THEME_STORAGE_KEY est dupliqué dans public/index.html : le petit
   script inline y relit la même clé AVANT le premier rendu pour éviter le flash
   blanc (React ne monte qu'après la première peinture). Les deux doivent rester
   synchronisés. */
import { ThemeProvider as NextThemeProvider, useTheme } from "next-themes";

export const THEME_STORAGE_KEY = "gocab-boost-theme";

/* `forcedTheme` impose un thème à l'arbre sans TOUCHER au réglage mémorisé :
   la page passager s'affiche en clair, et l'opérateur qui revient sur la
   console y retrouve son mode sombre intact. C'est aussi ce qui neutralise le
   suivi du thème système tant qu'il est posé — next-themes ignore le
   changement de `prefers-color-scheme` quand un thème est forcé. */
export function ThemeProvider({ children, forcedTheme }) {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      forcedTheme={forcedTheme}
      storageKey={THEME_STORAGE_KEY}
      // Coupe les `transition` le temps du basculement : sans ça, chaque
      // surface anime sa couleur séparément et le changement part en bouillie.
      disableTransitionOnChange
    >
      {children}
    </NextThemeProvider>
  );
}

export { useTheme };
